// extracted by mini-css-extract-plugin
export default {"task-content":"styles_task-content__pD92B"};